import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API, errText } from "@/site/common";
import { saveToken } from "@/site/member";

export function GoogleCallback({ onDone }) {
  const { hash } = useLocation(), go = useNavigate(), done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.slice(1)).get("session_id");
    const next = sessionStorage.getItem("es_next"); sessionStorage.removeItem("es_next");
    axios.post(`${API}/member/google`, { session_id: sid })
      .then((r) => { saveToken(r.data.token); onDone(r.data.member); toast.success(`Hoş geldiniz ${r.data.member.name?.split(" ")[0] || ""}`); go(r.data.member.complete ? next || "/hesabim" : "/hesabim/profil", { replace: true }); })
      .catch((e) => { toast.error(errText(e)); onDone(null); go("/giris", { replace: true }); });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <div className="min-h-[60vh] grid place-items-center text-slate-500" data-testid="google-callback"><span className="inline-flex items-center gap-3"><Loader2 className="animate-spin text-orange-500" />Giriş yapılıyor…</span></div>;
}
